var exports = {
  "iE": "xaee3c4fa--06ba60--wrapper",
  "Q5": "xaee3c4fa--06ba60--_hover",
  "P7": "xaee3c4fa--06ba60--inner-wrapper",
  "kZ": "xaee3c4fa--06ba60--image-wrapper",
  "DD": "xaee3c4fa--06ba60--title",
  "RD": "xaee3c4fa--06ba60--info-wrapper",
  "L1": "xaee3c4fa--06ba60--category",
  "h_": "xaee3c4fa--06ba60--description",
  "UH": "xaee3c4fa--06ba60--footer-wrapper",
  "l8": "xaee3c4fa--06ba60--views",
};

module.exports = exports;
